import type MediumUser from '../../../../types/MediumUser';

export type UserSelectionStateType = 'FILTER' | 'STATIC';

interface AbstractUserSelectionState {
    type: UserSelectionStateType;
}

export type HiringDateRelative = {
    beforeOrAfter: 'before' | 'after';
    unit: 'week' | 'month' | 'year';
    count: number;
};

export interface UserSelectionFilterState extends AbstractUserSelectionState {
    type: 'FILTER';
    propertyFilters: {
        location: string[];
        role: string[];
        department: string[];
        team: string[];
        employmentType: string[];
        hiringDate: { from?: string; to?: string } | null;
        hiringDateRelative: HiringDateRelative | null;
        jobLevel: string[];
        division: string[];
    };
    hierarchyFilters: {
        reportsOf: string[];
        level: 'MANAGER' | 'NON_MANAGER' | null;
    };
    idFilters: {
        excluded: string[];
        included: string[];
    };
}

export interface UserSelectionStaticState extends AbstractUserSelectionState {
    type: 'STATIC';
    userIds: string[];
}

export type UserSelectionState = UserSelectionFilterState | UserSelectionStaticState;

export type UserSelectionProps<T extends AbstractUserSelectionState = UserSelectionState> = {
    value: T;
    onChange: (value: T) => void;
    allUsers: MediumUser[];
};

export type UserSelectionFilterAndStaticProps<T extends AbstractUserSelectionState = UserSelectionState> = {
    title: string;
    value: { FILTER: UserSelectionFilterState; STATIC: UserSelectionStaticState };
    onChange: (value: T) => void;
    allUsers: MediumUser[];
};

export type StringUserProperty =
    | 'employmentType'
    | 'location'
    | 'role'
    | 'department'
    | 'team'
    | 'jobLevel'
    | 'division';

export const mkEmptyUserSelectionFilterState = (): UserSelectionFilterState => ({
    type: 'FILTER',
    propertyFilters: {
        location: [],
        role: [],
        department: [],
        team: [],
        employmentType: [],
        hiringDate: null,
        hiringDateRelative: null,
        jobLevel: [],
        division: [],
    },
    hierarchyFilters: {
        reportsOf: [],
        level: null,
    },
    idFilters: {
        excluded: [],
        included: [],
    },
});

export const mkEmptyUserSelectionStaticState = (): UserSelectionStaticState => ({
    type: 'STATIC',
    userIds: [],
});
